"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setCookies = exports.setCookiesByInputValue = exports.cookieIsSet = exports.CookiesEnum = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
const googleConsent_1 = require("@web/cookiesSettings/googleConsent");
var CookiesEnum;
(function (CookiesEnum) {
    CookiesEnum["ALL"] = "all";
    CookiesEnum["NONE"] = "none";
    CookiesEnum["SELECTED"] = "selected";
})(CookiesEnum || (exports.CookiesEnum = CookiesEnum = {}));
const setupConsentParameters = (consentParameterNames, value) => {
    consentParameterNames.split(',').forEach((consentStorageName) => {
        googleConsent_1.consentStorageObject[consentStorageName] = value;
    });
};
const setCookie = (cookieName, consentParameterNames) => {
    if (cookieName) {
        js_cookie_1.default.set(cookieName, '1', {
            expires: 365,
            sameSite: 'lax',
            secure: true,
        });
    }
    if (consentParameterNames) {
        setupConsentParameters(consentParameterNames, googleConsent_1.ConsentValueEnum.DENIED);
    }
};
const unsetCookie = (cookieName, consentParameterNames) => {
    if (cookieName) {
        js_cookie_1.default.remove(cookieName);
    }
    if (consentParameterNames) {
        setupConsentParameters(consentParameterNames, googleConsent_1.ConsentValueEnum.GRANTED);
    }
};
const cookieIsSet = (cookieName) => js_cookie_1.default.get(cookieName) === '1';
exports.cookieIsSet = cookieIsSet;
const setCookiesByInputValue = (selectedCookiesEnum, inputs, callback) => {
    inputs.forEach((input) => {
        const { cookieName } = input.dataset;
        const { consentParameterNames } = input.dataset;
        if (selectedCookiesEnum === CookiesEnum.ALL) {
            unsetCookie(cookieName, consentParameterNames);
        }
        if (selectedCookiesEnum === CookiesEnum.NONE || selectedCookiesEnum === CookiesEnum.SELECTED) {
            if (input.checked === false) {
                setCookie(cookieName, consentParameterNames);
            }
            else {
                unsetCookie(cookieName, consentParameterNames);
            }
        }
    });
    callback(googleConsent_1.consentStorageObject);
};
exports.setCookiesByInputValue = setCookiesByInputValue;
const setCookies = (selectedCookiesEnum, optionsList, callback) => {
    const { tagsPolicyConfirmedCookieName } = optionsList.dataset;
    if (tagsPolicyConfirmedCookieName && (0, exports.cookieIsSet)(tagsPolicyConfirmedCookieName) === false) {
        setCookie(tagsPolicyConfirmedCookieName, undefined);
    }
    const inputs = Array.from(optionsList.querySelectorAll('input'));
    (0, exports.setCookiesByInputValue)(selectedCookiesEnum, inputs, (consentSettings) => {
        (0, googleConsent_1.consentGrantedAdStorage)(consentSettings);
    });
    callback();
};
exports.setCookies = setCookies;
